<template>
    <div class="cashier">
        <router-view></router-view>
    </div>
</template>

<script>
    export default {
        name: "Cashier",
    }
</script>

<style scoped>
    @import "../../../commons/css/main.css";


</style>